export const GRADE_LEVEL_LIST = {
    grade_kindergarten: 'Kindergarten',
    grade_1: '1st grade',
    grade_2: '2nd grade',
    grade_3: '3rd grade',
    grade_4: '4th grade',
    grade_5: '5th grade',
    grade_6: '6th grade',
    grade_7: '7th grade',
    grade_8: '8th grade',
    grade_9: '9th grade',
    grade_10: '10th grade',
    grade_11: '11th grade',
    grade_12: '12th grade',
    grade_other: 'Other'
};

export const COUNTRY_OPTIONS = {
    unitedStates: 'United States',
    canada: 'Canada',
    other: 'Other'
};

export const SIGNUP_EXTERNAL_LINKS = {
    privacy_policy_url: '/privacy',
    terms_conditions_url: '/terms'
};

export const BLOG_CATEGORIES = {
    community: 'Community',
    events: 'Events',
    new_features: 'New Features'
};

export const BLOG_INCREMENT = 6;